import React, { useState, useEffect, useContext } from "react";
import { platformApi } from "../../../api";
import {
  Button,
  Input,
  Typography,
  Dropdown,
  Row,
  Menu,
  Col,
  Icon,
  message,
  Tooltip
} from "antd";
import { withRouter } from "react-router-dom";
import {
  LeftOutlined
} from '@ant-design/icons';
import WrappedForm from "./IDForm";
import IDTable from "./IDTable";
const { Search } = Input;
const { Title } = Typography;
const { Item } = Menu;
import { ContextAPI } from "../../../ContextAPI";
const IDGenerator = (props) => {

  const [limit, setLimit] = useState(10);
  const [dataSource, setdataSource] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [spinning, setSpinning] = useState(false);
  const [selected, setSelected] = useState(null);
  const [editable, setEditable] = useState(true)
  const [createAccess, setCreateAccess] = useState(false);
  const [modifyAccess, setModifyAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);
  const [open, setOpen] = useState(false);

  const [search, setSearch] = useState('')
  const { loginCredintials } = useContext(ContextAPI);

  const addData = (data) => {
    if (data.id) {
      platformApi
        .put(`/api/idCreation/${data.id}`, data)
        .then((res) => {
          const { data } = res;
          if (data.code === 200) {
            const { response } = data;
            if (response.code === 200) {
              setSelected(null);
              setdataSource((prev) =>
                prev.map((obj) => (obj.id === response.data.id ? response.data : obj))
              );
              message.success("ID saved successfully", 2);
            } else if (response.code === 400) {
              message.error("", 2);
            } else {
              message.error("Unable to save ID", 2);
            }
          } else {
            message.error("Unable to save ID", 2);
          }
        })
        .catch((err) => {
          message.error("Unable to save ID", 2);
          console.error("Error on ID : ", err);
        });
    } else {
      platformApi
        .post("/api/idCreation/", data)
        .then((res) => {
          const { data } = res;
          if (data.code === 200) {
            const { response } = res.data;
            if (response.code === 200) {
              setdataSource((prev) => [response.data, ...prev]);
              setCount((prevCount) => prevCount + 1);
              message.success("ID added successfully");
            }
            else if (response.code === 400) {
              message.error("Static text param already exists for selected sub module")
            }
            else {
              message.error("Error in ID creation");
            }
          } else {
            message.error("Error in ID creation");
          }
        })
        .catch((err) => {
          console.error("Error on ID : ", err);
        });
    }
  };
  const setPageData = (string, val) => {
    setSpinning(true);
    platformApi
      .post("/api/idCreation/get", { page: val ? val : page, size: limit, searchString: string })
      .then((res) => {
        setSpinning(false);
        const { data } = res;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            setdataSource(response.data.id);
            setCount(response.data.count);
          } else {
            message.error("Unable to fetch ID", 2);
          }
        } else {
          message.error("Unable to fetch ID", 2);
        }
      })
      .catch((err) => {
        setSpinning(false);
        console.error("Error on financer : ", err);
        message.error("Unable to fetch Manufacturer", 2);
      });
  };

  useEffect(() => {
    setPageData(search)
  }, [page, limit, search])

  useEffect(() => {
    loginCredintials.roleAccess &&
      loginCredintials.roleAccess.map((each) => {
        if (each.subModule === "idgenerator") {
          if (each.access.create) {
            setCreateAccess(true);
          }
          if (each.access.update) {
            setModifyAccess(true);
          }
          if (each.access.delete) {
            setDeleteAccess(true);
          }
        }
      });
    setPageData();
  }, []);

  const deleteData = (id) => {
    let temp = page != 1 && dataSource.length === 1;
    // if (page != 1 && dataSource.length === 1) {
    //   setPage(page - 1)
    // }
    setSpinning(true);
    platformApi
      .delete(`/api/idCreation/${id}`)
      .then((result) => {
        setSpinning(false);
        const { data } = result;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            if (temp) {
              setPage(1)
              setPageData(null, 1)
            }
            else {
              setPageData();
            }
            message.success("Deleted Sucessfully", 2);
          } else {
            message.error("Unable to delete ID", 2);
          }
        } else {
          message.error("Unable to delete ID", 2);
        }
      })
      .catch((error) => {
        setSpinning(false);
        message.error("Unable to delete Vehicle", 2);
        console.error("Error on Vehicle : ", error);
      });
  };
  const getMenu = () => {
    let size = count / 10 + (count % 10 ? 1 : 0);
    const menus = [];
    menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item onClick={() => { setLimit(menu), setPage(1) }} key={menu}>
        {menu}
      </Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;
  return (
    <div>
      <div className="accessories-head">
        <Title style={{ width: "60%" }} level={4}>
          <Tooltip placement="topLeft" title={"Back to Company Master"}>
            <Button
              style={{ margin: "0 20px" }}
              onClick={() => props.history.push("/autoadmin/company")}
            >
              <LeftOutlined />
            </Button>
          </Tooltip>
          ID Generator [{count}]
          <span style={{ marginLeft: "1rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit}
                &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          placeholder="Search ID"
          className="searchbar-div-manufacturer"
          style={{ width: "30%" }}
          onSearch={(event) => {
            setPage(1)
            setSearch(event);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearch(null)
              setPage(1)
            }
          }}
        />
        <Button
          onClick={() => {
            setOpen(true);
            setEditable(true)
          }}
          style={{ margin: "0 3%", width: "20%" }}
          type="primary"
          disabled={!createAccess}
        >
          Generate New Id
        </Button>
      </div>
      {open && <WrappedForm
        addData={addData}
        modalData={selected}
        create={createAccess}
        setSelected={setSelected}
        open={open}
        setOpen={setOpen}
        setPageData={setPageData}
        editable={editable}
        setEditable={setEditable}
      />
      }
      <div>
        <IDTable
          pagination={{
            onChange: (page) => {
              setPage(page);
            },
            pageSize: limit,
            defaultCurrent: 1,
            total: count,
            current: page,
            showQuickJumper: true,
          }}
          dataSource={dataSource}
          spinner={spinning}
          openModal={(data, type) => {
            setSelected(data);
            setOpen(true);
            setEditable(type)
          }}
          deleteData={deleteData}
          deleteAccess={deleteAccess}
          modify={modifyAccess}
        />
      </div>
    </div>
  );
};
export default withRouter(IDGenerator);
